module.exports = __webpack_public_path__ + "static/media/music_category.216c8527.jpg";